import 'react-perfect-scrollbar/dist/css/styles.css';
import 'nprogress/';

import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import React, { Suspense } from 'react';
import { useRoutes } from 'react-router-dom';
import { useSelector } from 'react-redux';
import 'src/mixins/chartjs';
import routes from 'src/routes';
import ThemeProvider from './styles/ThemeProvider';

const App = () => {
  const { user, dashboards } = useSelector((state) => ({
    user: state.auth.user,
    dashboards: state.site.dashboards
  }));
  const routing = useRoutes(routes(!!user, dashboards, dashboards[0]?.children[0]?.key || null));

  return (
    <ThemeProvider>
      <Suspense fallback={<></>}>
        {routing}
      </Suspense>
    </ThemeProvider>
  );
};

export default App;
